module.exports = __webpack_public_path__ + "media/images/loading-spinner-d5309a290fe8ed196b5c0fa6d64d8c75.svg";